import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alm-items-button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["deploy-btn", {'is-deployed-disabled': _ctx.isButtonDisabled}]),
      role: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleDeploy($event)))
    }, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Deploy_Text')), 3)
  ]))
}